/**
 * DEV-only performance helpers for Organized Tours (search / results / profile).
 */

export function orgTourPerfNow() {
  if (typeof performance !== "undefined" && performance.now) {
    return performance.now();
  }
  return Date.now();
}

export function logOrgTourSearchPerf(tag, payload) {
  if (!import.meta.env?.DEV) return;
  console.log(`[${tag}]`, { ts: new Date().toISOString(), ...payload });
}

export function pushOrgTourTracePanelSample(sample) {
  if (!import.meta.env?.DEV || typeof window === "undefined") return;
  const w = window;
  const arr = Array.isArray(w.__ORG_TOUR_TRACE_PANEL__) ? w.__ORG_TOUR_TRACE_PANEL__ : [];
  arr.push({ at: Date.now(), ...sample });
  w.__ORG_TOUR_TRACE_PANEL__ = arr.slice(-40);
}
